import type { ProductOriginFilterValue } from "$routes/inventory/_lib/product-origin-filter";
import type { SortOption } from "$routes/inventory/_lib/sort-by-select";
import { InventorySearchOrderProperty } from "$routes/inventory/_lib/types";
import merge from "lodash.merge";
import { useState } from "react";
import { useSortByOptions } from "./use-sort-by-options";

interface InventoryTableFilterStateValues {
  loading: boolean;
  locationId: string | null;
  sortBy: SortOption;
  searchTerm: string;
  itemType: ProductOriginFilterValue;
  defaultInventorySortBy: SortOption;
}
export interface InventoryTableFilterState
  extends InventoryTableFilterStateValues {
  setLoading: (loading: boolean) => void;
  setLocationId: (locationId: string | null) => void;
  setSortBy: (sortOption: SortOption) => void;
  setSearchTerm: (searchTerm: string) => void;
  setItemType: (itemType: ProductOriginFilterValue) => void;
  reset: (values?: Partial<InventoryTableFilterStateValues>) => void;
  /**
   * This a hack that is used to ensure the table component can be forced to refresh when needed (i.e. if we need to force refetching/regrouping of child rows etc.)
   */
  incrementRefreshKey: () => void;
  refreshKey: number;
}

export function useInventoryTableFilterState(): InventoryTableFilterState {
  const sortByOptions = useSortByOptions();
  const defaultInventorySortBy =
    sortByOptions[InventorySearchOrderProperty.UPDATED_AT];
  const defaultValues: InventoryTableFilterStateValues = {
    loading: false,
    locationId: null,
    sortBy: defaultInventorySortBy,
    searchTerm: "",
    itemType: null,
    defaultInventorySortBy,
  };
  const [sortBy, setSortBy] = useState<SortOption>(defaultValues.sortBy);
  const [searchTerm, setSearchTerm] = useState<string>(
    defaultValues.searchTerm,
  );
  const [locationId, setLocationId] = useState<string | undefined>(
    defaultValues.locationId,
  );
  const [itemType, setItemType] = useState<ProductOriginFilterValue>(
    defaultValues.itemType,
  );
  const [loading, setLoading] = useState<boolean>(defaultValues.loading);
  const [refreshKey, setRefreshKey] = useState<number>(0);

  const reset = (resetValues?: Partial<InventoryTableFilterStateValues>) => {
    const mergedValues: InventoryTableFilterStateValues = merge(
      defaultValues,
      resetValues,
    );
    setLoading(mergedValues.loading);
    setLocationId(mergedValues.locationId);
    setSearchTerm(mergedValues.searchTerm);
    setSortBy(mergedValues.sortBy);
    setItemType(mergedValues.itemType);
  };

  return {
    loading,
    setLoading,

    locationId,

    setLocationId,
    sortBy,
    setSortBy,
    searchTerm,
    setSearchTerm,
    itemType,
    setItemType,
    reset,
    defaultInventorySortBy,
    refreshKey,
    incrementRefreshKey: () => setRefreshKey(refreshKey + 1),
  };
}
